import { call, put, takeLatest } from 'redux-saga/effects';

import * as formActions from './formActions.js';
import { updateFormApiCall } from './formAPI.js';

function* updateFormSaga({ payload }) {
  try {
    const { data } = yield call(updateFormApiCall, payload);
    yield put(formActions.formUpdateStore(data));
  } catch (error) {
    yield put(formActions.formUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* formWatcher() {
  yield takeLatest(formActions.formUpdateRequest.type, updateFormSaga);
}
